import { UserPermission } from "@/models/userPermission.ts";

/**
 * Currently, only super-admins require MFA sign-in. If they are at the first
 * stage of login, they will be granted the usePasswordlessCredential and useRecoveryCode permissions,
 * they can then step-up their permission to super-admin using MFA.
 * @param userPermissions
 */
export default (userPermissions: string[]) => {
  return (
    !userPermissions.includes(UserPermission.superAdmin) &&
    userPermissions.includes(UserPermission.usePasswordlessCredential) &&
    userPermissions.includes(UserPermission.useRecoveryCode)
  );
};
